import { useState, useEffect } from 'react'

function getStorageValue(key, defaultValue) {
  try {
    // getting stored value
    const saved = window.localStorage.getItem(key)
    const initial = JSON.parse(saved)
    return initial || defaultValue
  } catch (error) {
    console.error('Error parsing JSON:', error)
    return defaultValue
  }
}

export const useLocalStorage = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    return getStorageValue(key, defaultValue)
  })

  useEffect(() => {
    // storing input name
    window.localStorage.setItem(key, JSON.stringify(value))
  }, [key, value])

  return [value, setValue]
}
